<!-- Wrapper con scroll -->
<div style="max-height: 65vh; overflow-y: auto; padding-right: 0.25rem;">

  <!-- STEP 0: METHOD SELECTION -->
  <div *ngIf="step === 'method'">
    <div class="form-header">
      <h3 class="form-title">Configurar 2FA</h3>
      <p class="form-subtitle">Elige tu método de autenticación</p>
    </div>

    <div
      style="background: #ecfdf5; border: 1px solid #a7f3d0; border-radius: 6px; padding: 0.75rem; margin-bottom: 1rem;">
      <div style="display: flex; gap: 0.5rem; align-items: start;">
        <i class="fas fa-shield-alt" style="color: #059669; font-size: 0.875rem; margin-top: 0.125rem;"></i>
        <p style="font-size: 0.6875rem; color: #047857; margin: 0; line-height: 1.3;">Elige cómo quieres proteger tu
          cuenta.</p>
      </div>
    </div>

    <!-- Method Options -->
    <div style="display: flex; flex-direction: column; gap: 0.75rem; margin-bottom: 1rem;">

      <!-- Google Authenticator Option -->
      <button type="button" (click)="selectMethod('authenticator')"
        style="width: 100%; background: white; border: 2px solid #e5e7eb; border-radius: 8px; padding: 1rem; text-align: left; cursor: pointer; transition: all 0.2s;"
        onmouseover="this.style.borderColor='#01abce'; this.style.backgroundColor='#f0f9ff'"
        onmouseout="this.style.borderColor='#e5e7eb'; this.style.backgroundColor='white'">
        <div style="display: flex; align-items: start; gap: 0.875rem;">
          <div
            style="background: linear-gradient(135deg, #dbeafe, #bfdbfe); border-radius: 8px; padding: 0.75rem; flex-shrink: 0;">
            <i class="fas fa-mobile-alt" style="color: #2563eb; font-size: 1.25rem;"></i>
          </div>
          <div style="flex: 1;">
            <p style="font-size: 0.875rem; font-weight: 600; color: #1e293b; margin: 0 0 0.25rem 0;">Google
              Authenticator</p>
            <p style="font-size: 0.75rem; color: #64748b; margin: 0; line-height: 1.4;">Usa una app de autenticación
              para generar códigos.</p>
            <div style="display: flex; align-items: center; gap: 0.375rem; margin-top: 0.5rem;">
              <span
                style="background: #10b981; color: white; font-size: 0.625rem; font-weight: 600; padding: 0.125rem 0.5rem; border-radius: 12px;">RECOMENDADO</span>
              <span style="font-size: 0.625rem; color: #94a3b8;">Más seguro</span>
            </div>
          </div>
          <i class="fas fa-chevron-right" style="color: #cbd5e1; font-size: 0.875rem; margin-top: 0.25rem;"></i>
        </div>
      </button>

      <!-- SMS Option -->
      <button type="button" (click)="selectMethod('sms')"
        style="width: 100%; background: white; border: 2px solid #e5e7eb; border-radius: 8px; padding: 1rem; text-align: left; cursor: pointer; transition: all 0.2s;"
        onmouseover="this.style.borderColor='#01abce'; this.style.backgroundColor='#f0f9ff'"
        onmouseout="this.style.borderColor='#e5e7eb'; this.style.backgroundColor='white'">
        <div style="display: flex; align-items: start; gap: 0.875rem;">
          <div
            style="background: linear-gradient(135deg, #fef3c7, #fde68a); border-radius: 8px; padding: 0.75rem; flex-shrink: 0;">
            <i class="fas fa-sms" style="color: #d97706; font-size: 1.25rem;"></i>
          </div>
          <div style="flex: 1;">
            <p style="font-size: 0.875rem; font-weight: 600; color: #1e293b; margin: 0 0 0.25rem 0;">SMS</p>
            <p style="font-size: 0.75rem; color: #64748b; margin: 0; line-height: 1.4;">Recibe códigos por mensaje de
              texto.</p>
            <div style="display: flex; align-items: center; gap: 0.375rem; margin-top: 0.5rem;">
              <span
                style="background: #fbbf24; color: #78350f; font-size: 0.625rem; font-weight: 600; padding: 0.125rem 0.5rem; border-radius: 12px;">PRÓXIMAMENTE</span>
              <span style="font-size: 0.625rem; color: #94a3b8;">En desarrollo</span>
            </div>
          </div>
          <i class="fas fa-chevron-right" style="color: #cbd5e1; font-size: 0.875rem; margin-top: 0.25rem;"></i>
        </div>
      </button>
    </div>

  </div>

  <!-- LOADING -->
  <div *ngIf="step === 'loading'">
    <div class="form-header">
      <h3 class="form-title">Configurando 2FA</h3>
      <p class="form-subtitle">Preparando código...</p>
    </div>
    <div style="text-align: center; padding: 2.5rem 0;">
      <div
        style="width: 40px; height: 40px; border: 3px solid #e5e7eb; border-top-color: #01abce; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto;">
      </div>
    </div>
  </div>

  <!-- STEP: PHONE INPUT (para SMS) -->
  <div *ngIf="step === 'phone-input'">
    <div class="form-header">
      <h3 class="form-title">Configurar SMS 2FA</h3>
      <p class="form-subtitle">Ingresa tu número de teléfono</p>
    </div>

    <!-- Error Messages -->
    <div *ngIf="errors && errors.length > 0" class="error-container" style="margin-bottom: 1rem;">
      <div class="error-alert" *ngFor="let error of errors"
        style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 0.875rem; display: flex; gap: 0.625rem; align-items: start;">
        <i class="fas fa-exclamation-triangle" style="color: #dc2626; margin-top: 0.125rem;"></i>
        <span style="color: #991b1b; font-size: 0.875rem;">{{ error.msg }}</span>
      </div>
    </div>

    <!-- Phone Input -->
    <div style="margin-bottom: 1.5rem;">
      <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #374151; margin-bottom: 0.5rem;">
        Número de Teléfono
      </label>
      <div style="display: flex; align-items: center; gap: 0.5rem;">
        <span
          style="padding: 0.875rem 1rem; background: #f3f4f6; border: 2px solid #e5e7eb; border-radius: 8px; font-size: 0.9375rem; color: #6b7280; font-weight: 600;">+58</span>
        <input type="tel" [(ngModel)]="phoneNumber" placeholder="4141234567" maxlength="10"
          style="flex: 1; padding: 0.875rem 1rem; border: 2px solid #e5e7eb; border-radius: 8px; font-size: 0.9375rem; transition: all 0.2s;"
          onfocus="this.style.borderColor='#01abce'" onblur="this.style.borderColor='#e5e7eb'">
      </div>
      <p style="font-size: 0.75rem; color: #6b7280; margin-top: 0.5rem;">
        Ingresa solo el número sin el código de país (ej: 4141234567 o 04141234567)
      </p>
    </div>

    <!-- Buttons -->
    <div style="display: flex; gap: 0.75rem;">
      <button type="button" (click)="backToMethodSelection()" [disabled]="submit_disabled"
        style="flex: 0 0 auto; background: white; border: 2px solid #e5e7eb; border-radius: 8px; padding: 0.875rem 1.25rem; color: #64748b; font-size: 0.9375rem; font-weight: 600; cursor: pointer; transition: all 0.2s;"
        onmouseover="if(!this.disabled) { this.style.borderColor='#01abce'; this.style.color='#01abce'; }"
        onmouseout="if(!this.disabled) { this.style.borderColor='#e5e7eb'; this.style.color='#64748b'; }">
        <i class="fas fa-arrow-left"></i>
      </button>
      <button type="button" (click)="sendSMSCode()"
        [disabled]="!phoneNumber || phoneNumber.length < 10 || submit_disabled"
        style="flex: 1; background: #01abce; border: 2px solid #01abce; border-radius: 8px; padding: 0.875rem 1.5rem; color: white; font-size: 0.9375rem; font-weight: 600; cursor: pointer; transition: all 0.2s;"
        [style.opacity]="!phoneNumber || phoneNumber.length < 10 || submit_disabled ? '0.5' : '1'"
        [style.cursor]="!phoneNumber || phoneNumber.length < 10 || submit_disabled ? 'not-allowed' : 'pointer'"
        onmouseover="if(!this.disabled) { this.style.background='#0194b3'; this.style.borderColor='#0194b3'; }"
        onmouseout="if(!this.disabled) { this.style.background='#01abce'; this.style.borderColor='#01abce'; }">
        <i class="fas" [class.fa-paper-plane]="!submit_disabled" [class.fa-spinner]="submit_disabled"
          [class.fa-spin]="submit_disabled" style="margin-right: 0.5rem;"></i>
        {{ submit_disabled ? 'Enviando...' : 'Enviar Código' }}
      </button>
    </div>
  </div>

  <!-- STEP 1: SCAN QR -->
  <div *ngIf="step === 'scan'">
    <div class="form-header">
      <h3 class="form-title">Configurar 2FA</h3>
      <p class="form-subtitle">Protege tu cuenta</p>
    </div>

    <!-- Alert -->
    <div
      style="background: #ecfdf5; border: 1px solid #a7f3d0; border-radius: 6px; padding: 0.75rem; margin-bottom: 1rem;">
      <div style="display: flex; gap: 0.5rem; align-items: start;">
        <i class="fas fa-shield-alt" style="color: #059669; font-size: 0.875rem; margin-top: 0.125rem;"></i>
        <div style="flex: 1;">
          <p style="font-size: 0.75rem; font-weight: 600; color: #065f46; margin: 0 0 0.125rem 0;">Recomendado</p>
          <p style="font-size: 0.6875rem; color: #047857; margin: 0; line-height: 1.3;">Agrega seguridad extra.</p>
        </div>
      </div>
    </div>

    <!-- Instructions -->
    <div style="background: #f8f9fa; border-radius: 6px; padding: 0.75rem; margin-bottom: 1rem;">
      <p style="font-size: 0.75rem; font-weight: 600; color: #1e293b; margin: 0 0 0.375rem 0;">Cómo configurar:</p>
      <ol style="margin: 0; padding-left: 1rem; font-size: 0.6875rem; color: #64748b; line-height: 1.4;">
        <li>Descarga Google Authenticator</li>
        <li>Selecciona "Agregar cuenta"</li>
        <li>Escanea el código QR</li>
      </ol>
    </div>

    <!-- QR Code -->
    <div style="text-align: center; margin-bottom: 0.875rem;">
      <div
        style="background: white; padding: 1rem; border-radius: 8px; border: 2px solid #e5e7eb; display: inline-block;">
        <img [src]="qrCode" alt="QR Code" style="width: 160px; height: 160px; display: block;">
      </div>
    </div>

    <!-- Manual Code -->
    <div style="text-align: center; margin-bottom: 1rem;">
      <p style="font-size: 0.6875rem; color: #64748b; margin-bottom: 0.375rem;">¿No puedes escanear?</p>
      <div
        style="background: #f1f5f9; border: 1px solid #cbd5e1; border-radius: 6px; padding: 0.5rem 0.75rem; display: inline-flex; align-items: center; gap: 0.5rem; max-width: 90%;">
        <code
          style="font-size: 0.6875rem; font-weight: 600; color: #334155; font-family: monospace; word-break: break-all;">{{ secret }}</code>
        <button type="button" (click)="copyBackupCodes()"
          style="background: none; border: none; color: #01abce; cursor: pointer; padding: 0.25rem; flex-shrink: 0;">
          <i class="fas fa-copy" style="font-size: 0.75rem;"></i>
        </button>
      </div>
    </div>

    <!-- Buttons -->
    <div style="display: flex; gap: 0.75rem;">
      <button type="button" (click)="backToMethodSelection()"
        style="flex: 0 0 auto; background: white; border: 2px solid #e5e7eb; border-radius: 8px; padding: 0.875rem 1.25rem; color: #64748b; font-size: 0.9375rem; font-weight: 600; cursor: pointer; transition: all 0.2s;"
        onmouseover="this.style.borderColor='#01abce'; this.style.color='#01abce'"
        onmouseout="this.style.borderColor='#e5e7eb'; this.style.color='#64748b'">
        <i class="fas fa-arrow-left"></i>
      </button>
      <button type="button" (click)="goToVerify()"
        style="flex: 1; background: #01abce; border: 2px solid #01abce; border-radius: 8px; padding: 0.875rem 1.5rem; color: white; font-size: 0.9375rem; font-weight: 600; cursor: pointer; transition: all 0.2s;"
        onmouseover="this.style.background='#0194b3'; this.style.borderColor='#0194b3'"
        onmouseout="this.style.background='#01abce'; this.style.borderColor='#01abce'">
        Continuar <i class="fas fa-arrow-right" style="margin-left: 0.5rem;"></i>
      </button>
    </div>
  </div>

  <!-- STEP 2: VERIFY -->
  <div *ngIf="step === 'verify'">
    <div class="form-header">
      <h3 class="form-title">Verificar Código</h3>
      <p class="form-subtitle">Ingresa el código de 6 dígitos</p>
    </div>

    <div
      style="background: #ecfdf5; border: 1px solid #a7f3d0; border-radius: 6px; padding: 0.75rem; margin-bottom: 1rem;">
      <p style="font-size: 0.6875rem; color: #047857; margin: 0; line-height: 1.3;">Ingresa el código de tu app de
        autenticación.</p>
    </div>

    <div *ngIf="errors && errors.length > 0" class="error-container" style="margin-bottom: 1.5rem;">
      <div class="error-alert" *ngFor="let error of errors"
        style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 1rem; display: flex; gap: 0.625rem; align-items: start;">
        <i class="fas fa-exclamation-triangle" style="color: #dc2626; margin-top: 0.125rem;"></i>
        <span style="color: #991b1b; font-size: 0.875rem;">{{ error.msg }}</span>
      </div>
    </div>

    <form [formGroup]="form" (ngSubmit)="verifyCode()" class="auth-form" style="margin-bottom: 1.5rem;">
      <div class="input-group" style="margin-bottom: 1.25rem;">
        <label for="code" class="input-label" style="font-size: 0.9375rem; margin-bottom: 0.625rem;">Código</label>
        <input type="text" id="code" formControlName="code" placeholder="000000" maxlength="6" class="auth-input"
          [class.error]="form.get('code')?.invalid && form.get('code')?.touched"
          style="text-align: center; font-size: 1.75rem; font-weight: 700; letter-spacing: 0.5rem; font-family: monospace; padding: 1rem; border: 2px solid #e5e7eb; border-radius: 8px; width: 100%;">
        <div *ngIf="form.get('code')?.invalid && form.get('code')?.touched" class="input-error"
          style="margin-top: 0.5rem;">
          <i class="fas fa-exclamation-circle"></i>
          <span *ngIf="form.get('code')?.errors?.['required']">Campo requerido</span>
          <span *ngIf="form.get('code')?.errors?.['pattern']">Debe ser 6 dígitos</span>
        </div>
      </div>

      <div style="display: flex; gap: 0.75rem;">
        <button type="button" (click)="step = 'scan'"
          style="flex: 0 0 auto; background: white; border: 2px solid #e5e7eb; border-radius: 8px; padding: 0.875rem 1.25rem; color: #64748b; font-size: 0.9375rem; font-weight: 600; cursor: pointer; transition: all 0.2s;"
          onmouseover="this.style.borderColor='#01abce'; this.style.color='#01abce'"
          onmouseout="this.style.borderColor='#e5e7eb'; this.style.color='#64748b'">
          <i class="fas fa-arrow-left"></i>
        </button>
        <button type="submit" [disabled]="!form.valid || submit_disabled"
          style="flex: 1; background: #01abce; border: 2px solid #01abce; border-radius: 8px; padding: 0.875rem 1.5rem; color: white; font-size: 0.9375rem; font-weight: 600; cursor: pointer; transition: all 0.2s; opacity: 1;"
          [style.opacity]="!form.valid || submit_disabled ? '0.5' : '1'"
          [style.cursor]="!form.valid || submit_disabled ? 'not-allowed' : 'pointer'"
          onmouseover="if(!this.disabled) { this.style.background='#0194b3'; this.style.borderColor='#0194b3'; }"
          onmouseout="if(!this.disabled) { this.style.background='#01abce'; this.style.borderColor='#01abce'; }">
          <i class="fas" [class.fa-check]="!submit_disabled" [class.fa-spinner]="submit_disabled"
            [class.fa-spin]="submit_disabled" style="margin-right: 0.5rem;"></i>
          {{ submit_disabled ? 'Verificando...' : 'Verificar' }}
        </button>
      </div>
    </form>
  </div>

  <!-- STEP 3: BACKUP CODES -->
  <div *ngIf="step === 'backup'">
    <div class="form-header">
      <h3 class="form-title">Códigos de Respaldo</h3>
      <p class="form-subtitle">Guárdalos en un lugar seguro</p>
    </div>

    <div
      style="background: #fef3c7; border: 1px solid #fde68a; border-radius: 6px; padding: 0.75rem; margin-bottom: 1rem;">
      <div style="display: flex; gap: 0.5rem; align-items: start;">
        <i class="fas fa-exclamation-triangle" style="color: #d97706; font-size: 0.875rem; margin-top: 0.125rem;"></i>
        <div style="flex: 1;">
          <p style="font-size: 0.75rem; font-weight: 600; color: #78350f; margin: 0 0 0.125rem 0;">¡Importante!</p>
          <p style="font-size: 0.6875rem; color: #92400e; margin: 0; line-height: 1.3;">Solo los verás una vez.</p>
        </div>
      </div>
    </div>

    <div
      style="background: #f8f9fa; border: 1px solid #e5e7eb; border-radius: 8px; padding: 1rem; margin-bottom: 1rem;">
      <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem; margin-bottom: 0.75rem;">
        <div *ngFor="let code of backupCodes"
          style="background: white; padding: 0.625rem; border-radius: 6px; border: 1px solid #e5e7eb; text-align: center;">
          <code
            style="font-size: 0.6875rem; font-weight: 600; color: #334155; font-family: monospace;">{{ code }}</code>
        </div>
      </div>

      <div style="display: flex; gap: 0.5rem;">
        <button type="button" (click)="downloadBackupCodes()"
          style="flex: 1; background: #3b82f6; color: white; border: none; border-radius: 6px; padding: 0.625rem; font-weight: 600; font-size: 0.75rem; cursor: pointer;">
          <i class="fas fa-download"></i> Descargar
        </button>
        <button type="button" (click)="copyBackupCodes()"
          style="flex: 1; background: #64748b; color: white; border: none; border-radius: 6px; padding: 0.625rem; font-weight: 600; font-size: 0.75rem; cursor: pointer;">
          <i class="fas fa-copy"></i> Copiar
        </button>
      </div>
    </div>

    <button type="button" (click)="complete()"
      style="width: 100%; background: #01abce; border: 2px solid #01abce; border-radius: 8px; padding: 0.875rem 1.5rem; color: white; font-size: 0.9375rem; font-weight: 600; cursor: pointer; transition: all 0.2s;"
      onmouseover="this.style.background='#0194b3'; this.style.borderColor='#0194b3'"
      onmouseout="this.style.background='#01abce'; this.style.borderColor='#01abce'">
      <i class="fas fa-check-circle" style="margin-right: 0.5rem;"></i> Finalizar
    </button>
  </div>

  <!-- STEP 4: COMPLETE -->
  <div *ngIf="step === 'complete'">
    <div style="text-align: center; padding: 1.5rem 0 1rem;">
      <div
        style="background: linear-gradient(135deg, #d1fae5, #a7f3d0); border-radius: 50%; width: 80px; height: 80px; display: inline-flex; align-items: center; justify-content: center; margin-bottom: 1rem;">
        <i class="fas fa-check-circle" style="color: #10b981; font-size: 2.5rem;"></i>
      </div>
      <h3 class="form-title" style="margin-bottom: 0.375rem;">¡Listo!</h3>
      <p class="form-subtitle">Tu cuenta está protegida</p>
    </div>

    <div style="background: #ecfdf5; border: 1px solid #a7f3d0; border-radius: 6px; padding: 0.75rem;">
      <p style="font-size: 0.6875rem; color: #047857; margin: 0; line-height: 1.3; text-align: center;">Ahora
        necesitarás un código al iniciar sesión.</p>
    </div>
  </div>

</div>

<style>
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
</style>

<style>
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
</style>